import { styled } from 'styled-components'

import {
  CurrencyStringDollars,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

import { SkeletonTextLine } from '../../ListingCardSkeleton/ui'
import type { BaseListingCardProps } from '../types'
import DividerSeparatedList from './DividerSeparatedList'

const StyledDividerList = styled(DividerSeparatedList)`
  ${Typography.Body4_Semibold}
  color: ${Colors.Semantic.Neutral.black};
`

const Divider = styled.span`
  height: 0.75rem;
  width: 0.0625rem;
  background: ${Colors.Semantic.Neutral.medium_grey};
`

const UnitsAndMsrp = ({ listing }: Pick<BaseListingCardProps, 'listing'>) => {
  return (
    <StyledDividerList
      Divider={Divider}
      values={[
        {
          key: 'units',
          node: listing.units ? (
            <FormattedMessage
              id="Auction.BidAmount.NumberOfUnits"
              values={{ value: listing.units }}
            />
          ) : null,
        },
        {
          key: 'msrp',
          node: listing.retailPrice ? (
            <FormattedMessage
              id="Auction.BidAmount.MSRP"
              values={{
                value: (
                  <CurrencyStringDollars
                    currency={listing.currency}
                    value={listing.retailPrice}
                  />
                ),
              }}
            />
          ) : null,
        },
      ]}
    />
  )
}

export default UnitsAndMsrp

export const UnitsAndMsrpSkeleton = () => (
  <StyledDividerList
    values={[
      {
        key: 'placeholder',
        node: <SkeletonTextLine width="11rem" testIdSuffix="units--msrp" />,
      },
    ]}
  />
)
